import React from 'react';

import { FaTimes } from 'react-icons/fa';

import SubscriptionSlotsPatternTable from '../../components/SubscriptionSlotsPattern/SubscriptionSlotsPatternTable';

import { buildSubscriptionChargeRows } from '../../utils/subscriptionChargeDisplay';

import { formatDisplayDate, formatDisplayDateTime } from '../../utils/dateFormat';
import { formatMoneyInr } from '../../utils/moneyFormat';

import {

  buildSlotPatternRows,

  formatSpecialtyWithRegion,

  resolveDietLabel,

  resolvePlanLabel,

  resolveRegionLabel,

  resolveSpecialtyLabel,

  weekdaysInSubscriptionRange,

} from '../../utils/subscriptionDisplay';

import './AccountLayout.css';



function formatMoney(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  return formatMoneyInr(v);
}



function formatDate(value) {

  return formatDisplayDate(value, '—');

}



function formatCreatedAt(value) {

  return formatDisplayDateTime(value, '—');

}



/**

 * @param {{

 *   subscription: object,

 *   onClose: () => void,

 *   onPay?: (sub: object) => void,

 *   paying?: boolean,

 * }} props

 */

export default function AccountSubscriptionDetailsModal({

  subscription,

  onClose,

  onPay,

  paying = false,

  onManageDeliveries,

}) {

  if (!subscription) return null;



  const snap = subscription.webPlanSnapshot || {};

  const user = subscription.subscriptionUserInformation || {};

  const address = subscription.subscriptionAddresses || {};

  const specialty = resolveSpecialtyLabel(subscription);

  const specialtyWithRegion = formatSpecialtyWithRegion(subscription);

  const region = resolveRegionLabel(subscription);

  const planName = resolvePlanLabel(subscription);

  const mealTypeLabel = resolveDietLabel(subscription)

    || (snap.isOrganic != null || snap.specialtyOrganic != null

      ? ((snap.isOrganic ?? snap.specialtyOrganic) ? 'Organic' : 'Regular')

      : null);

  const slotPatternRows = buildSlotPatternRows(subscription);

  const chargeRows = buildSubscriptionChargeRows(subscription, formatMoney);

  const products = Array.isArray(snap.products) ? snap.products : [];

  const itemSchedules = Array.isArray(snap.itemSchedules) ? snap.itemSchedules : [];

  const canPay = String(subscription.orderStatus || '').toUpperCase() === 'PAYMENTPENDING';

  const status = String(subscription.orderStatus || '').toUpperCase();

  const paidAmt = Number(subscription.amountPaid);

  const isUnpaidStatus = status === 'PENDING' || status === 'PAYMENTPENDING';

  const actuallyPaid =

    subscription.isPaid === true

    || (!isUnpaidStatus && Number.isFinite(paidAmt) && paidAmt > 0);



  const deliveryDays = snap.deliveryDayCount ?? snap.charges?.days ?? subscription.originalCount ?? null;

  const totalSlots = snap.deliverySlotCount

    ?? (Array.isArray(snap.mealSlots) ? snap.mealSlots.length : null)

    ?? (Array.isArray(snap.slotCodes) ? snap.slotCodes.length : null);

  const totalQty = products.reduce((sum, p) => sum + (Number(p.quantity) || 0), 0);



  const itemScheduleLines = itemSchedules.map((row) => {

    const product = products.find((p) => String(p.id) === String(row.productId) && p.slotId === row.slotId)

      || products.find((p) => String(p.id) === String(row.productId));

    const name = product?.name || row.productId || 'Product';

    const activeDays = weekdaysInSubscriptionRange(
      subscription.fromDate || snap.startDate,
      subscription.toDate || snap.endDate,
      row.days || [],
      snap.days || [],
    );
    const days = activeDays.length ? activeDays.join(', ') : '—';

    return `${row.slotId || 'Slot'}: ${name} (${days})`;

  });



  return (

    <div

      className="account-sub-detail-overlay"

      role="presentation"

      onClick={(e) => {

        if (e.target === e.currentTarget) onClose();

      }}

    >

      <div

        className="account-sub-detail-modal"

        role="dialog"

        aria-modal="true"

        aria-labelledby="account-sub-detail-title"

      >

        <header className="account-sub-detail-modal__header">

          <div>

            <h2 id="account-sub-detail-title">Subscription details</h2>

            <p>

              {subscription.subscriptionNumber || `ID ${subscription.id}`}

              {specialtyWithRegion ? ` · ${specialtyWithRegion}` : ''}

              {planName && planName !== '—' ? ` · ${planName}` : ''}

              {mealTypeLabel ? ` · ${mealTypeLabel}` : ''}

            </p>

          </div>

          <button type="button" className="account-sub-detail-modal__close" onClick={onClose} aria-label="Close">

            <FaTimes />

          </button>

        </header>



        <div className="account-sub-detail-modal__body">

          <section>

            <h3>Plan</h3>

            <dl className="account-sub-detail-grid">

              <div>

                <dt>Status</dt>

                <dd>{subscription.orderStatus || '—'}</dd>

              </div>

              {snap.title ? (

                <div>

                  <dt>Title</dt>

                  <dd>{snap.title}</dd>

                </div>

              ) : null}

              <div>

                <dt>Specialty</dt>

                <dd>{specialty}</dd>

              </div>

              <div>

                <dt>Plan</dt>

                <dd>{planName}</dd>

              </div>

              <div>

                <dt>Region</dt>

                <dd>{region || '—'}</dd>

              </div>

              {mealTypeLabel ? (

                <div>

                  <dt>Meal type</dt>

                  <dd>{mealTypeLabel}</dd>

                </div>

              ) : null}

              <div>

                <dt>Start</dt>

                <dd>{formatDate(subscription.fromDate)}</dd>

              </div>

              <div>

                <dt>End</dt>

                <dd>{formatDate(subscription.toDate)}</dd>

              </div>

              <div>

                <dt>Created</dt>

                <dd>{formatCreatedAt(subscription.created_at)}</dd>

              </div>

              <div>

                <dt>Deliveries</dt>

                <dd>

                  {subscription.remainingDeliveries ?? subscription.count}

                  {subscription.originalCount != null ? ` / ${subscription.originalCount}` : ''}

                </dd>

              </div>

              {deliveryDays != null ? (

                <div>

                  <dt>Delivery days count</dt>

                  <dd>{deliveryDays}</dd>

                </div>

              ) : null}

              {totalSlots != null ? (

                <div>

                  <dt>Total slots</dt>

                  <dd>{totalSlots}</dd>

                </div>

              ) : null}

              {products.length ? (

                <div>

                  <dt>Products selected</dt>

                  <dd>{products.length}</dd>

                </div>

              ) : null}

              {totalQty > 0 ? (

                <div>

                  <dt>Total quantity</dt>

                  <dd>{totalQty}</dd>

                </div>

              ) : null}

              {snap.scheduleLabel && snap.scheduleId !== 'individual_by_item' ? (

                <div>

                  <dt>Schedule</dt>

                  <dd>{snap.scheduleLabel}</dd>

                </div>

              ) : null}

            </dl>

          </section>



          {(subscription.lookupCode || snap.lookupCode || snap.qrCodeUrl) ? (

            <section>

              <h3>Tracking</h3>

              <dl className="account-sub-detail-grid">

                <div>

                  <dt>Lookup code</dt>

                  <dd className="account-sub-detail-money">

                    {subscription.lookupCode || snap.lookupCode || '—'}

                  </dd>

                </div>

                {snap.qrCodeUrl ? (

                  <div className="account-sub-detail-grid__span">

                    <dt>QR code</dt>

                    <dd>

                      <img

                        className="account-sub-detail-qr"

                        src={snap.qrCodeUrl}

                        alt="Subscription tracking QR code"

                      />

                    </dd>

                  </div>

                ) : null}

              </dl>

            </section>

          ) : null}



          <section>

            <h3>Meal slots &amp; pattern</h3>

            <SubscriptionSlotsPatternTable rows={slotPatternRows} />

          </section>



          <section>

            <h3>Customer & address</h3>

            <dl className="account-sub-detail-grid">

              <div>

                <dt>Name</dt>

                <dd>{user.name || '—'}</dd>

              </div>

              <div>

                <dt>Phone</dt>

                <dd>{user.mobileNumber || '—'}</dd>

              </div>

              <div>

                <dt>Email</dt>

                <dd>{user.emailID || '—'}</dd>

              </div>

              <div className="account-sub-detail-grid__span">

                <dt>Address</dt>

                <dd>

                  {[address.address, address.city, address.state, address.postalCode, address.country]

                    .filter(Boolean)

                    .join(', ') || '—'}

                </dd>

              </div>

            </dl>

          </section>



          <section>

            <h3>Pricing & charges</h3>

            <dl className="account-sub-detail-grid">

              {chargeRows.map(([label, value]) => (

                <div key={label}>

                  <dt>{label}</dt>

                  <dd className={label === 'Total amount' ? 'account-sub-detail-money' : undefined}>

                    {value}

                  </dd>

                </div>

              ))}

              <div>

                <dt>

                  {status === 'PAYMENTPENDING' && !actuallyPaid ? 'Amount due' : 'Paid'}

                </dt>

                <dd>

                  {actuallyPaid

                    ? formatMoney(paidAmt)

                    : status === 'PAYMENTPENDING'

                      ? formatMoney(subscription.remainingAmount ?? subscription.totalPrice)

                      : formatMoney(0)}

                </dd>

              </div>

              {actuallyPaid || status === 'PAYMENTPENDING' ? (

                <div>

                  <dt>Remaining</dt>

                  <dd>{formatMoney(subscription.remainingAmount)}</dd>

                </div>

              ) : null}

            </dl>

          </section>



          {products.length ? (

            <section>

              <h3>Selected products</h3>

              <ul className="account-sub-detail-history">

                {products.map((product, index) => (

                  <li key={`${product.id || product.name}-${index}`}>

                    {product.name || 'Product'} × {product.quantity ?? 0}

                    {product.price != null ? ` — ${formatMoney(product.price)}` : ''}

                    {product.includedInPlan ? ' (included in plan)' : ''}

                    {product.slotId ? ` · ${product.slotId}` : ''}

                  </li>

                ))}

              </ul>

            </section>

          ) : null}



          {itemScheduleLines.length ? (

            <section>

              <h3>Item delivery schedules</h3>

              <ul className="account-sub-detail-history">

                {itemScheduleLines.map((line) => (

                  <li key={line}>{line}</li>

                ))}

              </ul>

            </section>

          ) : null}



          {Array.isArray(subscription.deliveries) && subscription.deliveries.length > 0 ? (

            <section>

              <h3>Delivery history ({subscription.deliveries.length})</h3>

              <ul className="account-sub-detail-history">

                {subscription.deliveries.map((d) => (

                  <li key={d.id}>

                    {d.deliveryDate} — {d.status} — deducted {formatMoney(d.valueDeducted)}

                    {d.remainingAmountAfter != null

                      ? ` · rem ${formatMoney(d.remainingAmountAfter)}`

                      : ''}

                  </li>

                ))}

              </ul>

            </section>

          ) : null}

        </div>



        <footer className="account-sub-detail-modal__footer">

          <button type="button" className="account-sub-detail-modal__secondary" onClick={onClose}>

            Close

          </button>

          {onManageDeliveries ? (

            <button

              type="button"

              className="account-sub-detail-modal__secondary"

              onClick={() => onManageDeliveries(subscription)}

            >

              Manage deliveries

            </button>

          ) : null}

          {canPay && onPay ? (

            <button

              type="button"

              className="btn-primary"

              disabled={paying}

              onClick={() => onPay(subscription)}

            >

              {paying ? 'Opening…' : 'Pay now'}

            </button>

          ) : null}

        </footer>

      </div>

    </div>

  );

}


